<template>
  <section>
    <span class="section-title">Education</span>

    <ul class="experience-list">
      <li
        v-for="(item, index) in content.education"
        :key="index"
        class="bulleted-item"
      >
        <div class="item-header">
          <div class="item-info">
            <span class="item-name">{{ item.degree }}</span>
            <span class="item-subname">{{ item.college }}</span>
          </div>
          <span class="item-date">{{ item.duration }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { content } from "@/content/data";
</script>
